package team.platforma.materialextension.sample_screens

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.selection.toggleable
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.Checkbox
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.layout.LayoutCoordinates
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import materialextension.composeapp.generated.resources.Res
import materialextension.composeapp.generated.resources.compose_multiplatform
import materialextension.composeapp.generated.resources.settings
import org.jetbrains.compose.resources.painterResource
import team.platforma.multiplatform_material_extension.model.RequiredField
import team.platforma.multiplatform_material_extension.tooltips.ContentWithTooltip
import team.platforma.multiplatform_material_extension.tooltips.model.PopupPosition
import team.platforma.multiplatform_material_extension.ui.OutlinePasswordInputField
import team.platforma.multiplatform_material_extension.ui.OutlinePhoneInputField
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraOutlinedButton
import team.platforma.multiplatform_material_extension.ui.buttons.utils.ButtonText
import team.platforma.multiplatform_material_extension.util.isEnabled
import team.platforma.multiplatform_material_extension.util.isValid
import team.platforma.multiplatform_material_extension.util.keyGrabber
import team.platforma.multiplatform_material_extension.util.rememberFormValidator
import team.platforma.multiplatform_material_extension.util.setFormEnabled

@Composable
fun SignInSample() {
    var phone by remember { mutableStateOf("") }

    val form by rememberFormValidator()

    val enabled = form.isEnabled()

    var clearDelay by remember { mutableStateOf("20") }

    var showErrorDialog by remember { mutableStateOf(false) }

    var phoneRequired by remember {
        mutableStateOf(
            RequiredField(
                true,
                "Обязательное поле"
            )
        )
    }

    var passwordRequired by remember {
        mutableStateOf(
            RequiredField(
                true,
                "Обязательное поле"
            )
        )
    }

    var showSettingsDialog by remember { mutableStateOf(false) }
    val boxCoordinates = remember { mutableStateOf<LayoutCoordinates?>(null) }

    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        LazyColumn(
        ) {
            item {
                Column(
                    modifier = Modifier
                        .fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {

                    Icon(
                        painter = painterResource(Res.drawable.settings),
                        contentDescription = null,
                        modifier = Modifier.size(40.dp)
                            .clip(CircleShape)
                            .clickable {
                                showSettingsDialog = !showSettingsDialog
                            }
                    )

                    OutlinePhoneInputField(
                        value = phone,
                        containerModifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 16.dp),
                        inputFieldModifier = Modifier.fillMaxWidth(),
                        onPhoneChanged = {
                            phone = it
                        },
                        label = "Номер телефона",
                        formValidator = form,
                        formKey = "user_phone_input",
                        requiredField = phoneRequired,
                        helpMessage = "Формат: +7 (000) 000-00-00",
                        errorMessage = "Введен недопустимый символ",
                        validate = {

                        },
                        clearDelay = if (clearDelay.isEmpty()) 0L else clearDelay.toLong()
                    )


                    if (showSettingsDialog) {
                        Dialog(
                            onDismissRequest = { showSettingsDialog = false }
                        ) {
                            Card(
                                modifier = Modifier.fillMaxWidth(),
                                shape = RoundedCornerShape(8.dp)

                            ) {
                                Column(
                                    modifier = Modifier.padding(8.dp)

                                ) {
                                    Row(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(56.dp)
                                            .clip(CircleShape)
                                            .toggleable(
                                                value = phoneRequired.boolean,
                                                onValueChange = {
                                                    val copy =
                                                        phoneRequired.copy(boolean = !phoneRequired.boolean)
                                                    phoneRequired = copy
                                                },
                                                role = Role.Checkbox
                                            )
                                            .padding(horizontal = 8.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Text(
                                            text = "Номер телефона обязателен",
                                            style = MaterialTheme.typography.bodyLarge,
                                            modifier = Modifier.weight(1f)
                                        )
                                        Checkbox(
                                            checked = phoneRequired.boolean,
                                            onCheckedChange = {
                                                val copy = phoneRequired.copy(boolean = it)
                                                phoneRequired = copy
                                            }
                                        )
                                    }

                                    Spacer(modifier = Modifier.height(4.dp))

                                    TextField(
                                        value = clearDelay,
                                        onValueChange = {
                                            if (it.matches(Regex("^\\d*$"))) {
                                                clearDelay = it
                                            }
                                        },
                                        modifier = Modifier.fillMaxWidth()
                                            .padding(horizontal = 8.dp),
                                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                                        label = { Text(text = "Задержка удаления номера телефона") }
                                    )

                                    Spacer(modifier = Modifier.height(4.dp))

                                    Row(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(56.dp)
                                            .clip(CircleShape)
                                            .toggleable(
                                                value = phoneRequired.boolean,
                                                onValueChange = {
                                                    val copy =
                                                        passwordRequired.copy(boolean = !passwordRequired.boolean)
                                                    passwordRequired = copy
                                                },
                                                role = Role.Checkbox
                                            )
                                            .padding(horizontal = 16.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Text(
                                            text = "Пароль обязателен",
                                            style = MaterialTheme.typography.bodyLarge,
                                            modifier = Modifier.weight(1f)
                                        )
                                        Checkbox(
                                            checked = passwordRequired.boolean,
                                            onCheckedChange = {
                                                val copy = passwordRequired.copy(boolean = it)
                                                passwordRequired = copy
                                            }
                                        )
                                    }

                                    Spacer(modifier = Modifier.height(4.dp))

                                    Row(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(56.dp)
                                            .clip(CircleShape)
                                            .toggleable(
                                                value = enabled,
                                                onValueChange = {
                                                    form.setFormEnabled(!enabled)
                                                },
                                                role = Role.Checkbox
                                            )
                                            .padding(horizontal = 16.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Text(
                                            text = "Форма доступна",
                                            style = MaterialTheme.typography.bodyLarge,
                                            modifier = Modifier.weight(1f)
                                        )
                                        Checkbox(
                                            checked = form.isEnabled(),
                                            onCheckedChange = {
                                                form.setFormEnabled(it)
                                            }
                                        )
                                    }
                                }
                            }
                        }
                    }


                    var password by remember { mutableStateOf("") }

                    OutlinePasswordInputField(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 16.dp),
                        value = password,
                        onPasswordChanged = {
                            password = it
                        },

                        requiredField = passwordRequired,
                        helpMessage = "Введите пароль от 6 символов",
                        errorMessage = "Недопустимый символ",
                        formValidator = form,
                        formKey = "user_password",
                    )

                    Button(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 16.dp),
                        onClick = {
                            form.setFormEnabled(false)

                        },
                        enabled = form.isValid() && form.isEnabled()
                    ) {
                        Text(
                            text = "Sign in"
                        )
                    }

                    Row(
                        modifier = Modifier.fillMaxSize()
                            .onGloballyPositioned { boxCoordinates.value = it },
                        horizontalArrangement = Arrangement.SpaceAround
                    ) {
                        ContentWithTooltip(popupPosition = PopupPosition.TOP, content = {
                            Image(
                                painter = painterResource(Res.drawable.compose_multiplatform),
                                contentDescription = "Logout",
                                modifier = Modifier.clickable { showErrorDialog = true }
                            )
                        })
                        ContentWithTooltip(popupPosition = PopupPosition.TOP, content = {
                            Image(
                                painter = painterResource(Res.drawable.compose_multiplatform),
                                contentDescription = "Logout"
                            )
                        })
                        ContentWithTooltip(popupPosition = PopupPosition.TOP, content = {
                            Image(
                                painter = painterResource(Res.drawable.compose_multiplatform),
                                contentDescription = "Logout"
                            )
                        })
                        ContentWithTooltip(popupPosition = PopupPosition.BOTTOM, content = {
                            Image(
                                painter = painterResource(Res.drawable.compose_multiplatform),
                                contentDescription = "Logout"
                            )
                        })
                        ContentWithTooltip(popupPosition = PopupPosition.BOTTOM, content = {
                            Image(
                                painter = painterResource(Res.drawable.compose_multiplatform),
                                contentDescription = "Logout"
                            )
                        })
                        ContentWithTooltip(popupPosition = PopupPosition.BOTTOM, content = {
                            Image(
                                painter = painterResource(Res.drawable.compose_multiplatform),
                                contentDescription = "Logout"
                            )
                        })
                    }

                    if (showErrorDialog) {
                        team.platforma.multiplatform_material_extension.ui.dialog.CommonDialog(
                            onDismiss = {
                                showErrorDialog = false
                            },
                            title = {
                                Row(
                                    modifier = Modifier.fillMaxWidth()
                                        .padding(horizontal = 16.dp),
                                    horizontalArrangement = Arrangement.SpaceBetween,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Text(
                                        text = "Error",
                                        style = MaterialTheme.typography.titleLarge.copy(
                                            fontWeight = FontWeight.SemiBold,
                                            color = Color.Red
                                        )
                                    )
                                    IconButton(
                                        onClick = {
                                            showErrorDialog = false
                                        }
                                    ) {
                                        Icon(
                                            imageVector = Icons.Default.Close,
                                            contentDescription = "Close"
                                        )
                                    }
                                }
                            },
                            customStyle = null,
                            properties = DialogProperties(usePlatformDefaultWidth = false),
                        ) {
                            Column(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalAlignment = Alignment.CenterHorizontally
                            ) {
                                Text(
                                    modifier = Modifier.padding(16.dp),
                                    text = "Зафиксировано большое количество попыток входа в систему. Пожалуйста, повторите попытку через 60 секунд."
                                )
                                ExtraOutlinedButton(
                                    onClick = {
                                        showErrorDialog = false
                                    },
                                    buttonText = ButtonText(
                                        text = "Закрыть",
                                        textStyle = MaterialTheme.typography.bodyLarge.copy(
                                            fontWeight = FontWeight.SemiBold
                                        )
                                    ),
                                    modifier = Modifier.fillMaxWidth().padding(16.dp),
                                    keyGrabber = keyGrabber(),
                                    onClickKey = Key.Enter
                                )
                            }

                        }
                    }
                }
            }
        }
    }
}
